export default __webpack_public_path__ + "static/media/GLI.15dba4e1.png";